import { Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { ToolTipButton } from "nsitools-react";
import * as React from "react";

import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales";
import { ICustomButtonProps } from "./ICustomButtonProps";

interface IUploadSharepointButtonProps extends ICustomButtonProps {
  text: string;
}

export const UploadSharepointButton: React.FunctionComponent<IUploadSharepointButtonProps> = ({
  minimal = true,
  loading,
  disabled,
  text,
  intent = Intent.PRIMARY,
  onClick,
}) => {
  const { t } = useTl();
  return (
    <ToolTipButton
      tooltip={t(ETLCodes.DownloadDocument)}
      intent={intent}
      disabled={disabled}
      minimal={minimal}
      loading={loading}
      onClick={onClick}
      icon={IconNames.UPLOAD}
      text={text}
    />
  );
};
